<template>
  <v-card class="rounded-card pa-3" height="100%">
    <v-card-title class="pt-0 pb-0">
      <v-row>
        <v-col cols="3" class="text-right my-0 py-0"></v-col>
        <v-col cols="6">
          <h2 class="text-center primary--text font-weight-black">VENDER FACTURAS</h2>
        </v-col>
        <v-col cols="3" class="text-right">
          <v-btn
            fab
            right
            absolute
            width="30"
            height="30"
            class="mt-2 close-button"
            color="blue"
            @click="$emit('onClose')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-btn icon @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text style="height: 50vh;">
      <v-row v-if="errors.length" class="pb-1">
        <v-col cols="12" class="px-0 py-0">
          <v-alert
              dense
              outlined
              type="error"
              class="mb-0">
              <strong>Por favor especifica qué día de la semana y el plazo de pago de las siguientes empresas:</strong>
              <ul v-for="(company, index) in errors" :key="index">
                <li>{{company}}</li>
              </ul>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="errorsPO.length" class="pb-1">
        <v-col cols="12" class="px-0 py-0">
          <v-alert
              dense
              outlined
              type="error"
              class="mb-0">
              <strong>Por favor verifica los folios de la orden de compra de las siguientes empresas:</strong>
              <ul v-for="(company, index) in errorsPO" :key="index">
                <li>{{company}}</li>
              </ul>
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-form
          id="generalForm"
          ref="form"
          v-model="isValid"
          lazy-validation
        >
        <v-expansion-panels
          flat
          hover
          focusable
          id="panel"
          v-model="panel"
        >
          <v-expansion-panel v-show="failedFiles.length > 0">
            <v-expansion-panel-header v-slot="{ open }" class="error--text py-0" expand-icon="">
              <v-row no-gutters class="py-0" align="center">
                <v-col cols="4">
                  <h3 class="text-uppercase">
                    <v-icon x-large dark color="primary" v-if="open">mdi-chevron-up</v-icon>
                    <v-icon x-large dark color="primary" v-else>mdi-chevron-down</v-icon>
                    Archivos Inválidos
                  </h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-simple-table dense>
                <template v-slot:default>
                  <thead class="primary--text text-uppercase">
                    <th class="text-center font-weight-black" style="width: 30%;">Nombre del Archivo</th>
                    <th class="text-left font-weight-black" style="width: 70%;">Error</th>
                  </thead>
                  <tbody>
                    <tr  v-for="(file, index) in failedFiles" :key="index" class="primary--text dotted-border">
                      <td class="text-center">{{ file.fileName }}</td>
                      <td class="text-left">{{ file.motive.description }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="(group, index) in invoicesGroups"
            :key="index"
          >
            <v-expansion-panel-header v-slot="{ open }" class="primary--text py-0 pl-0" expand-icon="">
              <v-row no-gutters class="py-0" align="center">
                <v-col
                  sm="12"
                  md="12"
                  lg="7"
                  xl="7">
                  <h3 class="text-uppercase">
                    <v-icon x-large dark color="primary" v-if="open">mdi-chevron-up</v-icon>
                    <v-icon x-large dark color="primary" v-else>mdi-chevron-down</v-icon>
                    {{ group.receiverName }}
                  </h3>
                </v-col>
                <v-col
                  sm="12"
                  md="12"
                  lg="5"
                  xl="5"
                  class="text--secondary"
                >
                  <v-fade-transition hide-on-leave>
                    <h4 class="text-right primary--text" v-if="open && group.hasFB === false">
                      <v-icon large dark color="#F9A825">mdi-alert-decagram</v-icon>
                      Cuéntanos que día de la semana y el plazo de pago de tu cliente
                    </h4>
                    <h4 class="text-right primary--text" v-if="open && group.hasFB === true">
                      <v-icon large dark color="#F9A825">mdi-alert-decagram</v-icon>
                      Pago fijo a 45 días
                    </h4>
                    <v-row
                      v-if="!open && group.hasFB === false"
                      no-gutters
                      align="center"
                      style="width: 100%"
                    >
                      <v-col cols="9" class="text-right primary--text" v-if="group.paymentDays && group.paymentDays.weekDays">
                        <strong>Paga los días: </strong>
                        <v-icon dark color="primary" class="mx-1" v-if="group.paymentDays.weekDays.monday">mdi-alpha-l-circle</v-icon>
                        <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" v-else>mdi-alpha-l-circle-outline</v-icon>
                        <v-icon dark color="primary" class="mx-1" v-if="group.paymentDays.weekDays.tuesday">mdi-alpha-m-circle</v-icon>
                        <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" v-else>mdi-alpha-m-circle-outline</v-icon>
                        <v-icon dark color="primary" class="mx-1" v-if="group.paymentDays.weekDays.wednesday">mdi-alpha-m-circle</v-icon>
                        <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" v-else>mdi-alpha-m-circle-outline</v-icon>
                        <v-icon dark color="primary" class="mx-1" v-if="group.paymentDays.weekDays.thursday">mdi-alpha-j-circle</v-icon>
                        <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" v-else>mdi-alpha-j-circle-outline</v-icon>
                        <v-icon dark color="primary" class="mx-1" v-if="group.paymentDays.weekDays.friday === true">mdi-alpha-v-circle</v-icon>
                        <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" v-else>mdi-alpha-v-circle-outline</v-icon>
                      </v-col>
                      <v-col cols="3" class="text-left primary--text" v-if="group.paymentDays && group.paymentDays.weekDays">
                        <span class="ml-2">a un plazo de <strong class="primary--text font-weight-black">&nbsp; {{group.paymentDays.paymentDays || '0'}}&nbsp;</strong> días</span>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      align="center"
                      style="width: 100%"
                      v-if="!open && group.hasFB === true"
                    >
                      <v-col cols="12" class="text-right primary--text">
                        <strong>Pago fijo a 45 días</strong>
                      </v-col>
                    </v-row>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row
                style="width: 100%"
                class="mx-0 my-0"
                align="center"
                v-if="group.hasFB === false"
              >
                <v-col cols="10" class="text-right primary--text pt-1 pb-0" v-if="group.paymentDays && group.paymentDays.weekDays">
                  <strong>Paga los: </strong>
                  <v-icon dark color="primary" class="mx-1" @click="tooglePaymentDay(index, 'monday'); validate()" v-if="group.paymentDays.weekDays.monday === true">mdi-alpha-l-circle</v-icon>
                  <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" @click="tooglePaymentDay(index, 'monday'); validate()" v-else>mdi-alpha-l-circle-outline</v-icon>
                  <v-icon dark color="primary" class="mx-1" @click="tooglePaymentDay(index, 'tuesday'); validate()" v-if="group.paymentDays.weekDays.tuesday === true">mdi-alpha-m-circle</v-icon>
                  <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" @click="tooglePaymentDay(index, 'tuesday'); validate()" v-else>mdi-alpha-m-circle-outline</v-icon>
                  <v-icon dark color="primary" class="mx-1" @click="tooglePaymentDay(index, 'wednesday'); validate()" v-if="group.paymentDays.weekDays.wednesday === true">mdi-alpha-m-circle</v-icon>
                  <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" @click="tooglePaymentDay(index, 'wednesday'); validate()" v-else>mdi-alpha-m-circle-outline</v-icon>
                  <v-icon dark color="primary" class="mx-1" @click="tooglePaymentDay(index, 'thursday'); validate()" v-if="group.paymentDays.weekDays.thursday === true">mdi-alpha-j-circle</v-icon>
                  <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" @click="tooglePaymentDay(index, 'thursday'); validate()" v-else>mdi-alpha-j-circle-outline</v-icon>
                  <v-icon dark color="primary" class="mx-1" @click="tooglePaymentDay(index, 'friday'); validate()" v-if="group.paymentDays.weekDays.friday === true">mdi-alpha-v-circle</v-icon>
                  <v-icon dark :color="hasSelectedWeekDays(group.paymentDays.weekDays) ? 'primary' : 'error'" class="mx-1" @click="tooglePaymentDay(index, 'friday'); validate()" v-else>mdi-alpha-v-circle-outline</v-icon>
                </v-col>
                <v-col cols="2" class="primary--text pt-1 pb-0">
                  <v-text-field
                    class="small-suffix"
                    type="number"
                    outlined
                    dense
                    required
                    suffix="Días"
                    label="A un plazo de:"
                    @change="setPaymentDaysToChilds(group)"
                    :hide-details="'auto'"
                    :rules="daysRules"
                    v-model="group.paymentDays.paymentDays"
                    min="1"
                  />
                </v-col>
                <v-col cols="1" class="primary--text pt-1 pb-0">
                  <!-- <v-btn rounded dark color="#1374F2" class="special-button">
                      Aplicar<br> plazo
                  </v-btn> -->
                </v-col>
              </v-row>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead class="primary--text text-uppercase">
                    <th class="text-left pl-1" style="width: 5%;">
                      <input type="checkbox" class="special-checkbox" v-model="group.selectAll" @change="selectAll(group); validate();"/>
                      <label class="text-center font-weight-black"> Todas</label>
                    </th>
                    <th class="text-center font-weight-black" style="width: 8%;">Producto</th>
                    <th class="text-center font-weight-black" style="width: 8%;">Folio</th>
                    <th class="text-center font-weight-black" style="width: 12%;" v-if="group.hasFB">Orden Compra</th>
                    <th class="text-center font-weight-black" style="width: 12%;" v-if="!group.hasFB">Fecha de emisión</th>
                    <th class="text-center font-weight-black" style="width: 8%;" v-if="!group.hasFB">Días emisión hasta pago</th>
                    <th class="text-center font-weight-black" style="width: 12%;">Importe</th>
                    <th class="text-center font-weight-black" style="width: 12%;" v-if="group.hasFB">Fecha de emisión</th>
                    <th class="text-center font-weight-black" style="width: 12%;" v-if="!group.hasFB">Fecha de Venta</th>
                    <th class="text-center font-weight-black" style="width: 18%;">Fecha para pago</th>
                    <th class="text-center font-weight-black" style="width: 12%;">Días de crédito</th>
                    <th class="text-center font-weight-black" style="width: 5%;">¿Eliminar?</th>
                  </thead>
                  <tbody>
                    <tr  v-for="(invoice, indexInvoice) in saleInvoices(group)" :key="invoice.name" class="primary--text dotted-border">
                      <td class="text-left">
                        <v-switch
                          v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA ||
                            (invoice.productId === productTypes.FB.productId && $store.getters.isAuthFB) ||
                            (invoice.productId === productTypes.BI.productId && $store.getters.isAuthBI)"
                          @change="updateSelectedInvoices(invoice); invoice.paymentDays = group.paymentDays.paymentDays; setPaymentDays(invoice, group); validate()"
                          v-model="invoice.selected"
                          v-show="invoice.status !== FactoringDocumentStatus.RECHAZADA"
                          dense
                          flat
                          inset
                          hide-details
                          class="my-auto"
                          color="#5FC53D"/>
                      </td>
                      <td class="text-center primary--text text-uppercase font-weight-bold">
                        <span v-if="invoice.productId === productTypes.FB.productId">Factoraje American</span>
                        <span v-if="invoice.productId === productTypes.BI.productId">Blú Index</span>
                        <span v-if="invoice.productId !== productTypes.FB.productId && invoice.productId !== productTypes.BI.productId">{{ invoice.productId }}</span>
                      </td>
                      <td class="text-center"
                        :class="{
                          'disabled--text':
                            (invoice.productId === productTypes.FB.productId && !$store.getters.isAuthFB) || (invoice.productId === productTypes.BI.productId && !$store.getters.isAuthBI)
                        }"
                      >
                        {{ invoice.folio }}
                        <div v-if="group.errors.invoices[indexInvoice]" class="row-error">{{ group.errors.invoices[indexInvoice] }}</div>
                        <div v-if="invoice.status === FactoringDocumentStatus.RECHAZADA" class="row-error">{{ invoice.motive.description || 'Factura inválida' }}</div>
                      </td>
                      <td class="text-center" v-if="group.hasFB">
                          <v-text-field
                            class="center-input"
                            outlined
                            dense
                            placeholder="Folio de OC"
                            v-model="invoice.purchaseOrder"
                            :hide-details="'auto'"
                            v-if="invoice.selected"
                            @change="verifyChangesPurchaseOrder($event, invoice)"
                          />
                          <span v-else>-</span>
                        <div v-if="group.errorsPO.invoices[indexInvoice]" class="row-error">{{ group.errorsPO.invoices[indexInvoice] }}</div>
                      </td>
                      <td
                        class="text-center"
                        :class="{
                          'disabled--text':
                            (invoice.productId === productTypes.FB.productId && !$store.getters.isAuthFB) || (invoice.productId === productTypes.BI.productId && !$store.getters.isAuthBI)
                        }"
                        v-if="invoice.Product.code !== 'FB'"
                      >
                        {{ invoice.emittedOn }}
                      </td>
                      <td :class="emissionToPaymentDateValidation(invoice.emissionToPaymentDate)" v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA && invoice.Product.code !== 'FB'">
                        <span>{{ invoice.emissionToPaymentDate }}</span>
                      </td>
                      <td class="text-right"
                        :class="{
                          'disabled--text':
                            (invoice.productId === productTypes.FB.productId && !$store.getters.isAuthFB) || (invoice.productId === productTypes.BI.productId && !$store.getters.isAuthBI)
                        }"
                      >
                        {{ invoice.total | currency }} {{ invoice.currency }}
                      </td>
                      <td
                        class="text-center"
                        :class="{
                          'disabled--text':
                            (invoice.productId === productTypes.FB.productId && !$store.getters.isAuthFB) || (invoice.productId === productTypes.BI.productId && !$store.getters.isAuthBI)
                        }"
                        v-if="invoice.Product.code !== 'BI'"
                      >
                        {{ invoice.emittedOn }}
                      </td>
                      <td
                        class="text-center"
                        :class="{
                          'disabled--text':
                            (invoice.productId === productTypes.FB.productId && !$store.getters.isAuthFB) || (invoice.productId === productTypes.BI.productId && !$store.getters.isAuthBI)
                        }"
                        v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA && invoice.Product.code !== 'FB'"
                      >
                        {{ currentSaleDate }}
                      </td>
                      <td class="pr-2 pb-0 text-center" v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA && invoice.Product.code !== 'FB'">
                        <v-menu
                            :close-on-content-click="true"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="center-input"
                                outlined
                                dense
                                v-model="invoice.dueDate"
                                :hide-details="'auto'"
                                readonly
                                v-on="on"
                              />
                              <span></span>
                            </template>
                            <v-date-picker
                              :min="minDueDate"
                              :max="maxDueDate(currentSaleDate)"
                              :allowed-dates="date => allowedDates(date, group)"
                              @change="setDueDate($event, invoice, group);"
                              v-model="invoice.dueDate"
                              no-title/>
                        </v-menu>
                      </td>
                      <td class="pr-2 pb-0 text-center" v-if="invoice.Product.code === 'FB'">{{ invoice.dueDate }}</td>
                      <td class="pr-2 pb-0 text-center" v-if="invoice.status === FactoringDocumentStatus.RECHAZADA">-</td>
                      <td class="pl-1 pb-0 text-center">
                        <v-text-field
                          v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA && invoice.Product.code !== 'FB'"
                          type="number"
                          outlined
                          dense
                          required
                          suffix="Días"
                          class="small-suffix center-input"
                          v-model="invoice.paymentDays"
                          :hide-details="'auto'"
                          :rules="daysRules"
                          min="1"
                          @change="setPaymentDays(invoice, group);"
                        />
                        <span v-else-if="invoice.status === FactoringDocumentStatus.RECHAZADA">0</span>
                        <span v-else-if="invoice.Product.code === 'FB'">{{ invoice.paymentDays }} días</span>
                      </td>
                      <td class="text-center" @click="deleteInvoice(group, invoice)">
                        <v-icon v-if="invoice.status !== FactoringDocumentStatus.RECHAZADA" color="error">mdi-delete</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-form>
      </v-row>
      <!-- <v-row>
        <v-flex v-if="some.BI">
          <v-flex class="px-10 py-5 text-center">
            <h3 class="text-uppercase">{{ index.structure.BI.name }}</h3>
            <v-container v-for="(currency, j) in index.structure.BI.values" :key="j">
              <v-progress-linear
                v-if="index.BI[currency] && index.BI[currency].available > 0"
                :value="index.BI[currency].percentage"
                color="accent"
                height="30"
                rounded
                reactive
                class="my-2"
              >
                <template>
                  <strong class="white--text">Disponible {{ index.BI[currency].available | currency }} {{ currency }}</strong>
                </template>
              </v-progress-linear>
            </v-container>
          </v-flex>
        </v-flex>
        <v-flex v-if="some.FB">
          <v-flex class="px-10 py-5 text-center">
            <h3 class="text-uppercase">{{ index.structure.FB.name }}</h3>
            <v-container v-for="(currency, j) in index.structure.FB.values" :key="j">
              <v-progress-linear
                v-if="index.FB[currency] && index.FB[currency].available > 0"
                v-model="index.FB[currency].percentage"
                color="accent"
                height="30"
                rounded
                reactive
                class="my-2"
              >
                <template>
                  <strong class="white--text">Disponible {{ index.FB[currency].available | currency }} {{ currency }}</strong>
                </template>
              </v-progress-linear>
            </v-container>
          </v-flex>
        </v-flex>
      </v-row> -->
    </v-card-text>
    <v-card-text class="pb-0">
      <v-row
        style="width: 100%"
        class="mx-0 my-0"
        align="center"
        justify="center">
        <v-col cols="4" class="pt-0" v-if="!Utils.isObjectEmpty(infoBI)">
          <AvailableLine
              v-if="!Utils.isObjectEmpty(infoBI)"
              :progressData="progress('infoBI')"
              :creditInformation="infoBI"
              :showOverDraft="overdraftBI"
          />
        </v-col>
        <v-col cols="4" class="pt-0" v-if="!Utils.isObjectEmpty(infoFB)">
          <AvailableLine
              v-if="!Utils.isObjectEmpty(infoFB)"
              :progressData="progress('infoFB')"
              :creditInformation="infoFB"
              :showOverDraft="overdraftFB"
          />
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-flex d-block>
          <v-btn
            @click="reviewInvoices()"
            rounded
            color="#5C9DF2"
            class="font-weight-black white--text">Vender mis facturas</v-btn>
        </v-flex>
      </v-row>
      <v-dialog width="85%"
            scrollable
            v-model="saleSummary"
            overlay-color="#5B9DF2"
            transition="scale-transition"
            origin="center center"
            persistent>
          <SaleSummary @onClose="reviewInvoicesResponse" :invoicesToSell="invoicesToSell"/>
      </v-dialog>
      <v-dialog width="60%"
            scrollable
            v-model="authorizedSell"
            overlay-color="#5B9DF2"
            transition="scale-transition"
            origin="center center"
            persistent>
          <AuthorizeSelling @onClose="askForAuthorizationResponse"/>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import FactoringDocumentService from '@/services/FactoringDocumentService'
import FactoringCompanyService from '@/services/FactoringCompanyService'
import AvailableLine from '@/components/InvoiceSeller/AvailableLine'
import AuthorizeSelling from '@/components/AuthorizeSelling'
import SaleSummary from '@/components/SaleSummary'
import Utils from '@/common/utils'
import FactoringDocumentStatus from '@/common/FactoringDocumentStatus.js'
import Festivos from '@/common/Festivos.js'
import * as Sentry from '@sentry/vue'

export default {
  name: 'InvoiceLoader',
  components: {
    AvailableLine,
    AuthorizeSelling,
    SaleSummary
  },
  props: {
    invoicesGroups: Array,
    modal: Boolean,
    infoBI: Object,
    infoFB: Object,
    failedFiles: Array,
    productTypes: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    days: [
      { dayName: 'sunday', index: 0, letter: 'D' },
      { dayName: 'monday', index: 1, letter: 'L' },
      { dayName: 'tuesday', index: 2, letter: 'M' },
      { dayName: 'wednesday', index: 3, letter: 'Mi' },
      { dayName: 'thursday', index: 4, letter: 'J' },
      { dayName: 'friday', index: 5, letter: 'V' },
      { dayName: 'saturday', index: 6, letter: 'S' }
    ],
    Utils: Utils,
    FactoringDocumentStatus: FactoringDocumentStatus,
    isValid: true,
    panel: [0],
    selectedInvoices: [],
    totalSelected: 0,
    areCreditOverLimit: true,
    errors: [],
    errorsPO: [],
    progressData: {},
    overdraftBI: false,
    overdraftFB: false,
    authorizedSell: false,
    saleSummary: false,
    sendSummary: true,
    invoicesToSell: [],
    minDueDate: moment(new Date()).format('YYYY-MM-DD'),
    daysRules: [
      v => {
        const num = parseInt(v, 10)
        return (!isNaN(num) && num >= 0) || 'Debe haber un número'
      }
    ],
    currentDate: moment().format('YYYY-MM-DD'),
    emittionDate: null,
    paymentDate: null
  }),
  async mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        if (this.authorizedSell) { return }
        this.$emit('onClose', false)
      }
    })
  },
  async created () {
    this.progress('infoBI')
    this.progress('infoFB')
  },
  async updated () {
    await this.configureFB()
  },
  methods: {
    configureFB () {
      // Los que tienen Fb siempre son a 45 dias y no se pueden editar
      const dueDate = moment(moment()).add(45, 'days').format('YYYY-MM-DD')
      for (const group of this.invoicesGroups) {
        if (group.hasFB === true) {
          Vue.set(group.paymentDays, 'paymentDays', 45)
          for (const invoice of group.invoices) {
            const credit = this.$store.getters.creditsInformation.find(item => item.product === invoice.Product.code && item.moneda === invoice.currency)
            const daysBase = credit && credit.diasBase ? credit.diasBase : 360
            if (invoice.Product.code === 'FB') {
              Vue.set(invoice, 'paymentDays', 45)
              Vue.set(invoice, 'dueDate', dueDate)
              const comision = invoice.total * 45 * ((invoice.interestRate / 100) / daysBase)
              Vue.set(invoice, 'comision', comision)
            }
          }
        }
      }
    },
    async reviewInvoices () {
      await this.validate(true)
      if (this.totalSelected < 1) {
        this.isValid = false
        this.$swal('Error!', 'Selecciona las facturas que deseas vender', 'error')
        return
      }
      if (this.isValid) {
        this.saleSummary = true
      }
    },
    reviewInvoicesResponse (response, sendSummary) {
      if (response === true) {
        this.saleSummary = false
        this.authorizedSell = true
        this.sendSummary = sendSummary
        // this.askForAuthorization()
      } else {
        this.saleSummary = false
      }
    },
    // async askForAuthorization () {
    //   await this.validate()
    //   if (this.totalSelected < 1) {
    //     this.isValid = false
    //     this.$swal('Error!', 'Selecciona las facturas que deseas vender', 'error')
    //     return
    //   }
    //   if (this.isValid) {
    //     // this.authorizedSell = true
    //     this.saleSummary = true
    //   }
    // },
    askForAuthorizationResponse (response) {
      if (response === true) {
        this.authorizedSell = false
        this.preSellInvoices()
      } else {
        this.authorizedSell = false
      }
    },
    progress (obj) {
      const progressData = {
        used: { percent: 0, value: 0 },
        toSell: { percent: 0, value: 0 },
        available: { percent: 0, value: 0 }
      }

      if (!Utils.isObjectEmpty(this[obj])) {
        const secondaryCurrency = this[obj].creditCurrency === 'MXN' ? 'USD' : 'MXN'
        progressData.used.value = parseFloat(this[obj].creditUsed)
        progressData.used.percent = parseFloat((parseFloat(this[obj].creditUsed) * 100) / parseFloat(this[obj].creditLimit))

        const invoices = this.selectedInvoices.filter(invoice => invoice.Product.code === this[obj].Product.code)

        let totalPrincipalCurrency = invoices.filter(invoice => invoice.currency === this[obj].creditCurrency)
          .map((invoice) => parseFloat(invoice.adelanto > 0 ? invoice.adelanto : invoice.total))
          .reduce((previous, current) => previous + current, 0)

        const totalSecondaryCurrency = invoices.filter(invoice => invoice.currency === secondaryCurrency)
          .map((invoice) => parseFloat(invoice.adelanto > 0 ? invoice.adelanto : invoice.total))
          .reduce((previous, current) => previous + current, 0)

        if (this[obj].multimoneda === true) {
          if (this[obj].creditCurrency === 'MXN') {
            const difference = (totalSecondaryCurrency * this[obj].tipoCambio)
            totalPrincipalCurrency += difference
          }
          if (this[obj].creditCurrency === 'USD') {
            const difference = (totalSecondaryCurrency / this[obj].tipoCambio)
            totalPrincipalCurrency += difference
          }
        }

        progressData.available.value = parseFloat(this[obj].creditLimit - this[obj].creditUsed - totalPrincipalCurrency)
        progressData.available.percent = parseFloat((progressData.available.value * 100) / this[obj].creditLimit)

        progressData.toSell.value = totalPrincipalCurrency
        progressData.toSell.percent = 100 - progressData.used.percent - progressData.available.percent
        if (progressData.toSell.percent < 0) { progressData.toSell.percent = 0 }
      }
      this.progressData[obj] = progressData
      return progressData
    },
    maxDueDate (emittedOn) {
      return moment(emittedOn).add((process.env.VUE_APP_MAX_DAYS || 180), 'days').format('YYYY-MM-DD')
    },
    async tooglePaymentDay (index, day) {
      // https://code.tutsplus.com/tutorials/design-patterns-for-communication-between-vuejs-component--cms-32354
      const days = this.invoicesGroups[index].paymentDays.weekDays
      const simulatedDays = { ...days, [day]: !this.invoicesGroups[index].paymentDays.weekDays[day] }
      const allFalse = Object.values(simulatedDays).every(value => value === false)
      if (allFalse) {
        this.$swal('Error!', 'Debe seleccionar al menos un día de la semana', 'error')
      } else {
        days[day] = !this.invoicesGroups[index].paymentDays.weekDays[day]
        const group = this.invoicesGroups[index]
        Vue.set(this.invoicesGroups[index].paymentDays, 'weekDays', days)
        this.setPaymentDaysToChilds(group)
        this.$emit('update:invoicesGroups', this.invoicesGroups)
        this.$forceUpdate()
      }
    },
    async selectAll (group) {
      for (const invoice of group.invoices.filter(inv => inv.status !== FactoringDocumentStatus.RECHAZADA)) {
        const isAuthProduct = (this.$store.getters.isAuthBI && invoice.productId === this.productTypes.BI.productId) || (this.$store.getters.isAuthFB && invoice.productId === this.productTypes.FB.productId)
        if (isAuthProduct) {
          Vue.set(invoice, 'selected', group.selectAll)
          if (group.selectAll === false) {
            this.overdraftBI = false
            this.overdraftFB = false
          }
          await this.updateSelectedInvoices(invoice)
        }
      }
    },
    async updateSelectedInvoices (invoice) {
      const index = this.selectedInvoices.findIndex(inv => inv.uuid === invoice.uuid)
      if (invoice.selected === true) {
        if (index === -1) {
          await this.selectedInvoices.push(invoice)
          let remove = false
          // Verificar que haya linea disponible
          if (invoice.Product.code === 'BI') {
            this.overdraftBI = false
            if (this.progressData.infoBI.available.percent < 0) {
              remove = true
              Vue.set(invoice, 'selected', false)
              this.overdraftBI = true
            }
          }
          if (invoice.Product.code === 'FB') {
            this.overdraftFB = false
            if (this.progressData.infoFB.available.percent < 0) {
              remove = true
              Vue.set(invoice, 'selected', false)
              this.overdraftFB = true
            }
          }
          if (remove) {
            this.selectedInvoices.pop()
          }
        }
      } else {
        if (index >= 0) {
          this.selectedInvoices.splice(index, 1)
        }
      }
    },
    async createPaymentDays (group) {
      // Los dragones de las facturas descargadas del sat no se crean
      // por lo tanto hay que crearlas para setear los dias de pago
      let mustCreate = false

      const { data } = await FactoringCompanyService.getByRFC({
        rfc: group.receiverRFC,
        razonSocial: group.receiverName,
        clientId: this.$store.getters.user.clientId
      }).catch(async (error) => {
        console.error('error on createPaymentDays getByRFC', error)
        Sentry.captureException(error)
      })

      if (data.length === 0) { mustCreate = true }
      if (data.length > 1) {
        const dragonCompany = data.find(company => company.razonSocial.toLowerCase() === group.receiverName.toLowerCase())
        if (!dragonCompany) { mustCreate = true }
      }

      if (mustCreate) {
        await FactoringCompanyService.create({
          rfc: group.receiverRFC,
          razonSocial: group.receiverName,
          nombreComercial: group.receiverName
        }).catch(async (error) => {
          console.error('error on createPaymentDays createCompany', error)
          Sentry.captureException(error)
        })
      }

      try {
        const payload = {
          rfc: group.receiverRFC,
          razonSocial: group.receiverName,
          paymentDays: Object.assign(group.paymentDays.paymentDays),
          clientId: this.$store.getters.user.clientId,
          weekDays: group.paymentDays.weekDays
        }
        const { data } = await FactoringCompanyService.createPaymentDays(payload)
        return data
      } catch (error) {
        console.error('error on createPaymentDays updateDays', error)
        Sentry.captureException(error)
      }
    },
    async updatePaymentDays (group) {
      try {
        await this.createPaymentDays(group)
      } catch (error) {
        console.error(error)
      }
    },
    setDueDate (event, invoice, group) {
      const todayFormatted = moment(new Date()).format().substring(0, 10)
      let days = moment(event).diff(moment(todayFormatted), 'days')
      const credit = this.$store.getters.creditsInformation.find(item => item.product === invoice.Product.code && item.moneda === invoice.currency)
      const daysBase = credit && credit.diasBase ? credit.diasBase : 360

      if (invoice.Product.code === 'BI') {
        days = moment(event).diff(moment(this.currentDate), 'days')
      }

      Vue.set(invoice, 'paymentDays', days)
      this.setPaymentDays(invoice, group)
      invoice.comision = invoice.total * invoice.paymentDays * ((invoice.interestRate / 100) / daysBase)
    },
    async setPaymentDaysToChilds (group) {
      group.paymentDays.paymentDays = parseInt(group.paymentDays.paymentDays)

      if (group.paymentDays.paymentDays > parseInt(process.env.VUE_APP_MAX_DAYS || 180)) {
        group.paymentDays.paymentDays = parseInt(process.env.VUE_APP_MAX_DAYS || 180)
        this.$swal('Error!', 'El plazo no puede ser mayor a ' + (process.env.VUE_APP_MAX_DAYS || 180) + ' días', 'error')
      }
      for (const invoice of group.invoices) {
        if (group.paymentDays.paymentDays) {
          invoice.paymentDays = group.paymentDays.paymentDays
        }
        await this.setPaymentDays(invoice, group)
      }
    },
    setPaymentDays (invoice, group) {
      if (invoice.Product.code === 'FB') { return }
      const credit = this.$store.getters.creditsInformation.find(item => item.product === invoice.Product.code && item.moneda === invoice.currency)
      const daysBase = credit && credit.diasBase ? credit.diasBase : 360
      let paymentDays = parseInt(invoice.paymentDays) < (process.env.VUE_APP_MAX_DAYS || 180) ? parseInt(invoice.paymentDays) : parseInt(process.env.VUE_APP_MAX_DAYS || 180)
      const weekDays = group.paymentDays.weekDays ? group.paymentDays.weekDays : { monday: false, tuesday: false, wednesday: false, thursday: false, friday: false }
      let dueDate = moment(this.currentDate).add(paymentDays, 'days').format('YYYY-MM-DD')
      if (!(weekDays.monday || weekDays.tuesday || weekDays.wednesday || weekDays.thursday || weekDays.friday)) {
        weekDays.friday = true
        group.paymentDays.weekDays.friday = true
      }
      if (weekDays && (weekDays.monday || weekDays.tuesday || weekDays.wednesday || weekDays.thursday || weekDays.friday)) {
        while (true) {
          const paymentDay = moment(dueDate, 'YYYY-MM-DD').day()
          const selected = Object.entries(weekDays).filter(entry => entry[1]).some(entry => {
            const index = this.days.findIndex(day => day.dayName === entry[0])
            return index === paymentDay
          })
          if (selected && this.allowedDates(dueDate, group)) {
            break
          }
          dueDate = moment(dueDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
          paymentDays += 1
        }
      }
      if (invoice.Product.code === 'FB') {
        dueDate = moment(moment()).add(45, 'days').format('YYYY-MM-DD')
        Vue.set(invoice, 'paymentDays', 45)
        Vue.set(invoice, 'dueDate', dueDate)
        invoice.comision = invoice.total * 45 * ((invoice.interestRate / 100) / daysBase)
        return
      } else {
        dueDate = moment(this.currentDate).add(paymentDays, 'days').format('YYYY-MM-DD')
        Vue.set(invoice, 'paymentDays', paymentDays)
        Vue.set(invoice, 'dueDate', dueDate)
        invoice.comision = invoice.total * invoice.paymentDays * ((invoice.interestRate / 100) / daysBase)
      }
      const emittedDate = moment(invoice.emittedOn)
      const paymentDate = moment(dueDate)
      invoice.emissionToPaymentDate = paymentDate.diff(emittedDate, 'days')
      this.validate()
    },
    allowedDates (date, group) {
      const dayIndex = moment(date, 'YYYY-MM-DD').day()
      const dayName = this.days[dayIndex].dayName
      const weekDays = group.paymentDays.weekDays ? group.paymentDays.weekDays : { monday: false, tuesday: false, wednesday: false, thursday: false, friday: true }
      if (weekDays && !weekDays[dayName]) {
        return false
      }
      if (Festivos.esDiaInhabil(date)) {
        return false
      }
      return true
    },
    async validate (checkCurrencies = false) {
      this.isValid = true
      this.totalSelected = 0
      this.errors = []
      this.errorsPO = []
      const today = moment().format('YYYY-MM-DD')
      for (const group of this.invoicesGroups) {
        group.errors = { general: null, invoices: [] }
        group.errorsPO = { general: null, invoices: [] }
        const toSell = group.invoices.filter(inv => inv.selected === true)
        this.totalSelected += toSell.length

        if (toSell.length > 0) {
          for (const invoice of toSell) {
            const indexInvoice = group.invoices.findIndex(inv => inv.uuid === invoice.uuid)
            if (invoice.productId === this.productTypes.FB.productId) {
              invoice.purchaseOrder = invoice.purchaseOrder ? invoice.purchaseOrder.replace(/\s+/g, '') : ''
              invoice.purchaseOrder = invoice.purchaseOrder ? invoice.purchaseOrder.toUpperCase().trim() : ''
              if (!invoice.purchaseOrder) {
                group.errorsPO.invoices[indexInvoice] = 'Especifica el folio de la orden de compra'
                if (!this.errorsPO.includes(group.receiverName)) {
                  this.errorsPO.push(group.receiverName)
                }
                this.isValid = false
                continue
              }
            }

            if (!invoice.dueDate || invoice.paymentDays < 1) {
              group.errors.invoices[indexInvoice] = 'Verifica fecha para pago'
              this.isValid = false
              continue
            }
            if (invoice.dueDate <= today) {
              group.errors.invoices[indexInvoice] = 'La fecha para pago no puede ser menor o igual al día de hoy'
              if (!this.errors.includes(group.receiverName)) {
                this.errors.push(group.receiverName)
              }
              this.isValid = false
              continue
            }
            if (invoice.emissionToPaymentDate > (process.env.VUE_APP_MAX_DAYS || 180)) {
              group.errors.invoices[indexInvoice] = `La fecha de emisión a la de pago no puede ser mayor a ${process.env.VUE_APP_MAX_DAYS || 180} días`
              this.isValid = false
              continue
            }
          }
        }
      }

      this.invoicesToSell = this.invoicesGroups.map(group => group.invoices).flat()
        .filter(invoice => invoice.selected === true)

      if (checkCurrencies) {
        const originalLength = this.invoicesToSell.length
        const currenciesToSell = [...new Set(this.invoicesToSell.map(_ => _.currency))]

        const acceptInvoices = _ => {
          if (_.Product.code === 'FB') {
            if (!this.$store.getters.hasFBMXNAccount && _.currency === 'MXN') return false
            if (!this.$store.getters.hasFBUSDAccount && _.currency === 'USD') return false
          }
          if (_.Product.code === 'BI') {
            if (!this.$store.getters.hasBIMXNAccount && _.currency === 'MXN') return false
            if (!this.$store.getters.hasBIUSDAccount && _.currency === 'USD') return false
          }
          return true
        }

        this.invoicesToSell = this.invoicesToSell.filter(acceptInvoices)
        if (originalLength !== this.invoicesToSell.length) {
          const currenciesToProcess = [...new Set(this.invoicesToSell.map(_ => _.currency))]
          const notAccountCurrency = currenciesToSell.filter(_ => !currenciesToProcess.includes(_)).join(', ')
          await this.$swal('¡Atención!', `Las facturas en ${notAccountCurrency} no pudieron ser procesadas porque no se ha asociado una cuenta bancaria en esa moneda.`, 'warning')
        }
      }
    },
    hasSelectedWeekDays (weekDays) {
      return true
    },
    async preSellInvoices () {
      const loader = this.$loading.show()
      const groups = this.invoicesGroups.filter(item => item.invoices.some(invoice => invoice.selected))

      const invoicesToSell = this.invoicesGroups.map(group => group.invoices).flat()
        .filter(invoice => invoice.selected === true)

      if (invoicesToSell.length > 0) {
        const documents = []
        for (const invoice of invoicesToSell) {
          invoice.status = FactoringDocumentStatus.PREVENTA
          invoice.selected = false
          documents.push({
            documentId: invoice.documentId,
            dueDate: invoice.dueDate,
            paymentDays: invoice.paymentDays,
            comision: invoice.comision,
            soldBy: this.$store.getters.user.userId,
            interestRate: invoice.interestRate,
            porcentajeAdelanto: invoice.porcentajeAdelanto,
            total: invoice.total,
            purchaseOrder: invoice.purchaseOrder || '',
            productId: invoice.productId
          })
        }

        try {
          const { data } = await FactoringDocumentService.setAsPreSell({ documents, rfc: this.$store.getters.user.client.rfc })
          // El cliente hace muchas ventas de 1 factura, nos esperamos a que la venta se procese con el cron (5/Nov/20)
          // let dataToUpdate = {
          //   invoices: data,
          //   client: this.$store.getters.user.client
          // }
          // this.$store.dispatch('setPreSellInvoices', { data: dataToUpdate })
          let emails = []
          if (this.sendSummary) {
            emails = [this.$store.getters.user.email]
          }
          // Se envia siempre para validar envío, la diferencia es que si el usuario no marca la casilla, llegara copia al admin
          try {
            await FactoringDocumentService.sendSummary({
              rfc: this.$store.getters.user.client.rfc,
              numberOfSales: [data[0].numberOfSale],
              emails: emails
            })
          } catch (error) {
            console.error(error)
          }

          // try {
          //   FactoringDocumentService.processPreSells({
          //     rfc: this.$store.getters.user.client.rfc,
          //     clientId: this.$store.getters.user.clientId
          //   })
          // } catch (error) {
          //   console.error(error)
          // }

          // Se puso despues de marcar en preventa porque si se crea la dragón, se deben anexar los detalles de las facturas vendidas
          await Promise.all(
            groups.map(item => this.updatePaymentDays(item))
          )

          await this.createInvoicesReview({ invoices: data, clientId: this.$store.getters.user.client.clientId })
          // this.$store.dispatch('setPreSellInvoices', { data: dataToUpdate })
          this.$emit('onSell', invoicesToSell)
          loader.hide()
          this.$emit('onClose', true, invoicesToSell) // Aqui se manda el confetti
        } catch (error) {
          console.info(error)
        }
      }
    },
    async createInvoicesReview ({ invoices, clientId }) {
      try {
        invoices = invoices.map(inv => Object.assign({}, {
          status: inv.status,
          receiverRFC: inv.receiverRFC,
          receiverName: inv.receiverName,
          documentId: inv.documentId,
          companyId: inv.companyId,
          productId: inv.productId,
          clientId: inv.clientId
        }))
        await FactoringDocumentService.requestAuthorization({ invoices, clientId })
      } catch (error) {
        console.error(error)
      }
    },
    saleInvoices (group) {
      const invoices = group.invoices.filter(invoice =>
        invoice.status === FactoringDocumentStatus.AUTORIZADA ||
        invoice.status === FactoringDocumentStatus.REGISTRADO ||
        (
          invoice.status === FactoringDocumentStatus.RECHAZADA &&
          invoice.rejectedDate === moment().format('YYYY-MM-DD') &&
          invoice.motive.code !== 'DELETE_BY_USER'
        )
      )
      if (invoices.length === 0) {
        const index = this.invoicesGroups.findIndex(item => item.receiverRFC === group.receiverRFC)
        this.invoicesGroups.splice(index, 1)
      }
      return invoices
    },
    deleteInvoice (group, invoice) {
      this.$swal({
        title: '¿Deseas eliminar esta factura?',
        html: 'Ya no la podrás vender, pero la puedes volver a subir',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Si',
        confirmButtonColor: '#1374F2',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCloseButton: true,
        allowOutsideClick: true
      }).then(async (result) => {
        if (result.value) {
          const loader = this.$loading.show()
          try {
            const payload = {
              documentId: invoice.documentId,
              clientUserId: this.$store.getters.user.userId
            }
            const data = await FactoringDocumentService.deleteByUser(payload)
            if (data.deleted === true) {
              const toUpdate = this.$store.getters.invoices.map(item => item).filter(item => item.status === invoice.status && item.uuid !== invoice.uuid)
              await this.$store.dispatch('updateInvoicesByStatus', { invoices: toUpdate, status: invoice.status })
              group.invoices = group.invoices.filter(item => item.uuid !== invoice.uuid)
            } else {
              this.$swal('Error!', 'Acción no disponible de momento, intenta mas tarde', 'error')
            }
            // Vue.set(invoice, 'status', FactoringDocumentStatus.RECHAZADA)
          } catch (error) {
            this.$swal('Error!', 'Acción no disponible de momento, intenta mas tarde', 'error')
          }

          if (!this.invoicesGroups.map(item => item.invoices).flat().length) this.$emit('onClose', false)

          loader.hide()
        }
      })
    },
    emissionToPaymentDateValidation (days) {
      return (days < (process.env.VUE_APP_MAX_DAYS || 180)) ? 'pl-1 pb-0 text-center' : 'pl-1 pb-0 text-center error--text'
    },
    verifyChangesPurchaseOrder (event, invoice) {
      Vue.set(invoice, 'purchaseOrder', event)
      this.validate()
    }
  },
  computed: {
    index () {
      const object = {
        structure: { BI: { values: ['MXN', 'USD', 'EUR'], name: 'Blú Index' }, FB: { values: ['MXN', 'USD', 'EUR'], name: 'Factoraje American' } },
        BI: {
          MXN: {
            credit: null,
            available: 0,
            percentage: 0
          },
          USD: {
            credit: null,
            available: 0,
            percentage: 0
          },
          EUR: {
            credit: null,
            available: 0,
            percentage: 0
          }
        },
        FB: {
          MXN: {
            credit: null,
            available: 0,
            percentage: 0
          },
          USD: {
            credit: null,
            available: 0,
            percentage: 0
          },
          EUR: {
            credit: null,
            available: 0,
            percentage: 0
          }
        }
      }
      for (const creditType in object) {
        for (const currency in object[creditType]) {
          const credit = this.$store.getters.creditsInformation.find(credit => credit.moneda === currency && credit.product === creditType)
          if (credit) {
            object[creditType][currency].credit = credit || null
            let availableCreditLine = credit.limiteCredito - credit.saldoCreditos
            const selectedInvoicesTotalArr = this.invoicesGroups.map(group => group.invoices).flat().filter(invoice => invoice.selected === true && invoice.currency === currency && invoice.productId === this.productTypes[creditType].productId).map(invoice => (invoice.adelanto > 0 ? invoice.adelanto : invoice.total))
            availableCreditLine = selectedInvoicesTotalArr.length > 0 && availableCreditLine > 0 ? availableCreditLine - selectedInvoicesTotalArr.reduce((current, accum) => parseFloat(current) + parseFloat(accum)) : 0
            object[creditType][currency].available = availableCreditLine > 0 ? availableCreditLine : 0
            object[creditType][currency].percentage = object[creditType][currency].available > 0 && credit.limiteCredito > 0 ? (credit.limiteCredito / object[creditType][currency].available) * 100 : 100
          }
        }
      }
      return object
    },
    some () {
      const object = { BI: false, FB: false }
      for (const product in object) {
        object[product] = this.index.structure[product].values.some(currency => this.index[product][currency].credit !== null)
      }
      return object
    },
    currentSaleDate () {
      return moment().format('YYYY-MM-DD')
    }
  },
  filters: {
    twoZerosFilter (number) {
      return number.toFixed(2)
    },
    creditAvalaible (creditsInformation, product, currency) {
      // let credit = this.$store.getters.creditsInformation.find(credit => credit.product === product && credit.moneda === currency)
      return 0
    }
  },
  watch: {
    invoicesGroups: function (newVal, oldVal) {
      for (const group of this.invoicesGroups) {
        this.setPaymentDaysToChilds(group)
      }
    },
    selectedInvoices: function (oldVal, newVal) {
      this.progress('infoBI')
      this.progress('infoFB')
    }
  }
}
</script>

<style scoped>
  .rounded-card { border-radius: 50px !important; }
  .selected { background-color: blue }
  .non-selected { background-color: gray }
  .v-progress-linear { width: 50%; margin: auto }
  .factoring-icon { width: 2rem; }
  #generalForm { width: 100%; }

  tr.dotted-border td {
    border-bottom: 1px dashed #0420BF!important;
  }
  .row-error {
    color: #df0000 !important;
    line-height: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    font-size: 12px;
    font-weight: bold;
  }
</style>
